module.exports = __webpack_public_path__ + "img/Hair-system-lifestyle.660ca978.png";